import {mapState} from 'vuex'
import {appendQuery} from '@/utils'
import url from 'url'
import {
  initFinderShare,
  confirmFinderShare,
  spreadFinderShare,
  readFinderShare,
} from '@/api'

const menuList = ['menuItem:share:appMessage', 'menuItem:share:timeline', 'menuItem:share:qq', 'menuItem:share:weiboApp', 'menuItem:favorite', 'menuItem:share:facebook', 'menuItem:share:QZone']

export default {
  data() {
    return {
      shareOptions: {},
      shareId: null,
    }
  },
  computed: {
    ...mapState(['wechatUser', 'shareInfo', 'serviceConfig', 'cacheArticle']),
  },
  async created() {
    const query = url.parse(window.location.href, true).query
    if (query.isPayment === '1') {
      this.disableShare()
      return false
    }
    this.shareId = query.shareId || null
    if (this.shareId && query.shareFrom) {
      this.setReadFinderShare(query)
    }
    this.shareOptions = this.shareInfo
  },
  methods: {
    /**
     *
     * 新用户不在用户系统，等待新用户注册之后再次调用分享
     */
    setReadFinderShare(query) {
      if (this.isJustifyGatewayUser(query)) return
      let fn = () => {
        let timer = setTimeout(() => {
          clearTimeout(timer)
          if (this.isJustifyGatewayUser(query)) return
          fn()
        }, 100)
      }
      fn()
    },
    isJustifyGatewayUser(query) {
      if (this.wechatUser.username) {
        readFinderShare(this.wechatUser.username, this.shareId, query.shareFrom, this.serviceConfig.channel, this.shareOptions.title, this.shareOptions.columnName)
        return true
      }
      return false
    },
    /**
     * config share throught wechat api
     */
    async onMenuShare() {
      const query = url.parse(window.location.href, true).query
      const {brokerCode = '', brokerName = '', shareFrom = '', shareFromUnionId = ''} = query
      if (!this.shareOptions) return
      const link = this.shareOptions.link || await this.makeShareLink(window.location.href)
      // const {} = link
      const shareMethods = [
        'onMenuShareTimeline',
        'onMenuShareAppMessage',
        'onMenuShareQQ',
        'onMenuShareWeibo',
        'onMenuShareQZone',
      ]
      const title = this.shareOptions.title || this.serviceConfig.title
      let position =  ''
      if(location.hash.indexOf('/launcher-article/') > -1) {
        position = 'article_detail_page'
      }
      if(location.hash.indexOf('/launcher-article-list/') > -1) {
        position = 'column_page'
      }


      shareMethods.forEach((method) => {
        this.$wechat[method]({
          title,
          desc: this.shareOptions.desc || this.serviceConfig.desc,
          link: link,
          imgUrl: encodeURI(this.decodeURL(this.shareOptions.imgUrl || this.serviceConfig.image)),
          success: () => {
            if (this.wechatUser.isConsultant && this.isShareOrigin) {
              confirmFinderShare(this.shareId, this.serviceConfig.channel)
              this.shareId = null
              this.shareOptions.link = null
              this.onMenuShare().then()
            } else if (this.shareId) {
              spreadFinderShare(this.wechatUser.username, this.shareId, this.serviceConfig.channel, this.shareOptions.title, this.shareOptions.columnName)
            }

            let cacheArticle = this.cacheArticle || {}

            // 分享成功打点数据统计
            try {
              this.$sa.track('click_share_new', {
                is_success: true,
                page_title: position,
                type: this.shareInfo.articleType || '',
                news_title: title || cacheArticle.title,
                news_id: this.shareInfo.newsId || '', // 文章newsId
                news_describe: cacheArticle.introduction || '',
                column_id: this.shareOptions.columnId || cacheArticle.columnBeans && cacheArticle.columnBeans.map(i => i.id).join(','),
                column_name: this.shareOptions.columnName || cacheArticle.columnBeans && cacheArticle.columnBeans.map(i => i.name).join(','),
                adviser_id: brokerCode,
                adviser_name: brokerName, 
                article_url: link, // 分享链接
                pre_user_name: shareFrom, // 上个节点的 username
                pre_union_id: shareFromUnionId
              })
            } catch (error) {
              console.error(error)
            }
          },
          fail: () => {
            let cacheArticle = this.cacheArticle || {}
            this.$sa.track('click_share_new', {
              is_success: false,
              page_title: position,
              type: this.shareInfo.articleType || '',
              news_title: title || cacheArticle.title,
              news_id: this.shareInfo.newsId || '', // 文章newsId
              news_describe: cacheArticle.introduction || '',
              column_id: this.shareOptions.columnId || cacheArticle.columnBeans && cacheArticle.columnBeans.map(i => i.id).join(','),
              column_name: this.shareOptions.columnName || cacheArticle.columnBeans && cacheArticle.columnBeans.map(i => i.name).join(','),
              adviser_id: brokerCode,
              adviser_name: brokerName,
              article_url: link, // 分享链接
              pre_user_name: shareFrom, // 上个节点的 username
              pre_union_id: shareFromUnionId
            })
          }
        })
      })
    },
    /**
     * enbale share menus
     */
    async enableShare() {
      await this.$wechat.showMenuItems({
        menuList,
      })
    },
    /**
     * disable share menus
     */
    async disableShare() {
      const onWeixinBridgeReady = () => {
        window.WeixinJSBridge.call('hideOptionMenu')
      }
      if (typeof WeixinJSBridge === 'undefined') {
        if (document.addEventListener) {
          document.addEventListener('WeixinJSBridgeReady', onWeixinBridgeReady, false);
        } else if (document.attachEvent) {
          document.attachEvent('WeixinJSBridgeReady', onWeixinBridgeReady);
          document.attachEvent('onWeixinJSBridgeReady', onWeixinBridgeReady);
        }
      } else {
        onWeixinBridgeReady();
      }
      await this.$wechat.hideMenuItems({
        menuList,
      })
    },
    async makeShareLink(url) {
      if (this.wechatUser.isConsultant && !this.shareId) {
        this.shareId = await initFinderShare(this.wechatUser.username, this.$route.path, this.shareOptions.title, this.shareOptions.desc, this.serviceConfig.channel, this.shareOptions.columnName)
        this.isShareOrigin = true
      }
      this.shareId = this.shareId || null

      const shareFrom = this.wechatUser.username
      const shareFromUnionId = this.wechatUser.unionid

      const options = {
        removeNull: true,
        encodeComponents: false,
      }
      const newUrl = appendQuery(url, {state: null, code: null, shareId: this.shareId, shareFrom, shareFromUnionId, token: null, share_source: 'share'}, options)
      return newUrl
    },
    decodeURL(url) {
      let t1
      let t2 = url
      if (url) {
        do {
          t1 = t2
          try {
            t2 = decodeURI(t1)
          } catch (err) {
            t2 = unescape(t1)
          }
        } while (t2 !== t1)
        return t1
      }
      return url
    },
  },
}
